module.exports = __webpack_public_path__ + "static/media/medpad-slide5.91516303.png";